<template>
  <v-layout>
    <d-header
      fluid
      :actions="[
        {
          label: $t('create'),
          resource: 'owner',
          path: '/owners/create',
          primary: true,
          color: 'is-primary',
        },
      ]"
    >
      <h1 class="title">
        {{ $t("owners") }}
      </h1>
    </d-header>

    <v-owner-list />
  </v-layout>
</template>

<script>
import list from "./_list.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("owners").capitalize(),
    };
  },
  components: {
    "v-owner-list": list,
  },
};
</script>
